<template>
  <div class="product">
    <div class="top-img">
      <img style="width: 100%;" src="@/assets/images/k2hqdmpfendk2hqdmpfend.jpg"
           alt="YwgA84rAI">
    </div>
    <div class="product-view container" data-aos="fade-down" :data-aos-duration="1500">
      <MyTitle>
        <template v-slot:title><b style="color: #1E55AE">技术</b>与产品</template>
      </MyTitle>
      <ul v-loading="loading" element-loading-text="拼命加载中...">
        <li v-for="item in productList" :key="item.id"
            @click="showContent(item.content)"
            data-aos="zoom-in" :data-aos-duration="1500">
          <div class="seat-box">
            <el-image :src="item.image_url" lazy>
              <div slot="placeholder" class="image-slot">
                <img src="@/assets/images/loading.gif" alt="loading" style="width: 100px;">
              </div>
            </el-image>
            <p>{{ item.title }}</p>
          </div>
        </li>
      </ul>
    </div>
    <el-dialog :visible.sync="dialogArticleVisible">
      <div class="article-model" v-html='content.replace(/<img src/g, "<img data-src")'
           v-lazy-container="{ selector: 'img' }"></div>
      <el-empty :image-size="200" v-if="content.length === 0"></el-empty>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Product",
  data() {
    return {
      dialogArticleVisible: false,
      content: "",
      productList: [],
      loading: false,
    }
  },
  methods: {
    getProductList() {
      this.loading = true
      this.$api.reqProductList().then(results => {
        if (results.status === 200) {
          this.productList = results.results
        } else {
          Promise.reject('error')
        }
      }).catch(() => {
        this.$message({showClose: true, message: "技术产品列表请求失败！", type: "error"})
      }).finally(() => {
        this.loading = false
      })
    },
    showContent(content) {
      this.dialogArticleVisible = true
      this.content = content
    }
  },
  mounted() {
    this.getProductList()
  }
}
</script>

<style scoped lang="less">
.product {

  .product-view {
    padding: 80px 0;

    ul {
      display: flex;
      justify-content: center;
      flex-direction: row;
      flex-wrap: wrap;
      margin-top: 70px;
      min-height: 340px;

      li {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 400px;
        height: 397px;
        text-align: center;

        .seat-box {
          width: 285px;
          height: 335px;
          overflow: hidden;
          border: 1px solid #ebeef5;
          border-radius: 8px;
          box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
          font-size: 16px;
          background-color: #1E50AE;
          color: white;

          -webkit-transition: all 0.4s;
          transition: all 0.4s;

          &:hover {
            width: 310px;
            height: 360px;
            line-height: 32px;
          }

          a {
            color: #303133;
            cursor: pointer;
          }

          p {
            line-height: 52px;
          }

          .el-image {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 85%;
            background-color: #fffffd;
          }
        }
      }
    }
  }
}

/deep/ .el-dialog {
  margin-top: 5vh !important;
  padding: 60px 0;
  width: 1150px;

  .el-dialog__body {
    margin: auto;
    width: 900px;

    .article-model {
      min-height: 600px;
    }
  }
}
</style>